module.exports = __webpack_public_path__ + "img/shuobo_pic-text.b77df0c3.svg";